import React from "react";

/**
 * Базовые кнопки платформы (canon DESIGN_CANON_MASTER: CTA без glow,
 * pill-radius, accent только на primary). Единственный источник —
 * не переопределять инлайн-копиями на страницах.
 */

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  /** full — на всю ширину (default), auto — по контенту */
  width?: "full" | "auto";
  size?: "sm" | "md";
};

function widthCls(width: "full" | "auto" | undefined) {
  return width === "auto" ? "" : "w-full";
}

function sizeCls(size: "sm" | "md" | undefined) {
  return size === "sm" ? "py-1.5 px-3 text-xs" : "py-2.5 px-4 text-sm";
}

export function PrimaryButton(props: ButtonProps) {
  const { className = "", width, size, ...rest } = props;
  return (
    <button
      type="button"
      {...rest}
      className={`${widthCls(width)} ${sizeCls(size)} rounded-pill bg-accent hover:bg-accent-hover text-accent-on font-semibold disabled:opacity-50 press-scale ${className}`}
    />
  );
}

export function SecondaryButton(props: ButtonProps) {
  const { className = "", width, size, ...rest } = props;
  return (
    <button
      type="button"
      {...rest}
      className={`${widthCls(width)} ${sizeCls(size)} rounded-pill bg-bg-raised border border-bg-border text-fg-primary font-medium disabled:opacity-40 disabled:text-fg-muted press-scale ${className}`}
    />
  );
}

export function TertiaryButton(props: ButtonProps) {
  const { className = "", width, size, ...rest } = props;
  return (
    <button
      type="button"
      {...rest}
      className={`${widthCls(width)} ${sizeCls(size)} rounded-pill text-fg-secondary hover:text-fg-primary font-medium disabled:opacity-40 press-scale ${className}`}
    />
  );
}
